import { Popover } from '@mui/material';
import { anchorRef, bindTrigger } from 'material-ui-popup-state/hooks';

import {
  Table,
  TableBody,
  TableContainer,
  TableHeader,
  Pagination,
  FilterButton,
  LoadedContent,
} from '@occc/ui-design-system';

import { PastSubmissionsTableRow } from './past-submissions-table-row';
import { PastSubmissionsTableHead } from './past-submissions-table-head.component';

import { PastSubmission } from '../scan-data-weekly-file.types';
import { PastSubmissionFilterForm } from '../past-submission-filter';
import { usePastSubmissionsTableController } from '../hooks/use-past-submissions-table-container.hook';

export const PastSubmissionsTable = () => {
  const {
    paginationProps,
    loading,
    error,
    items,
    formFilter,
    popupState,
    popoverProps,
    onFilterFormSubmit,
    onFilterFormReset,
    isFilterSelected,
  } = usePastSubmissionsTableController();

  const renderData = (pastSubmissions: PastSubmission[]) => {
    return (
      <Table>
        <PastSubmissionsTableHead />
        <TableBody>
          {pastSubmissions.map((item: PastSubmission) => (
            <PastSubmissionsTableRow key={item.uuid} data={item} />
          ))}
        </TableBody>
      </Table>
    );
  };

  return (
    <>
      <TableContainer sx={{ mb: 1 }}>
        <TableHeader
          title='Past Submissions'
          actions={
            <FilterButton
              {...bindTrigger(popupState)}
              ref={anchorRef(popupState)}
              showBadge={isFilterSelected}
            />
          }
        />

        <LoadedContent<PastSubmission>
          error={error}
          loading={loading}
          items={items}
          renderData={renderData}
        />

        <Pagination {...paginationProps} />
      </TableContainer>

      <Popover
        {...popoverProps}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        slotProps={{
          paper: {
            sx: {
              maxWidth: 460,
              minWidth: 300,
            },
          },
        }}
        keepMounted
      >
        <PastSubmissionFilterForm
          onSubmit={onFilterFormSubmit}
          onReset={onFilterFormReset}
          initialValues={formFilter}
        />
      </Popover>
    </>
  );
};
